import { render, staticRenderFns } from "./fixItem.vue?vue&type=template&id=47675472&scoped=true"
import script from "./fixItem.vue?vue&type=script&lang=js"
export * from "./fixItem.vue?vue&type=script&lang=js"
import style0 from "./fixItem.vue?vue&type=style&index=0&id=47675472&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47675472",
  null
  
)

export default component.exports